// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { getType } from 'typesafe-actions';

import { RootAction, actionCreatorsList } from '../rootActionCreator';

export interface MainLayoutState {
  footerVisibleHeight: number;
}

const { updateFooterVisibleHeight } = actionCreatorsList;

export const initialState: MainLayoutState = {
  footerVisibleHeight: 0
};

export default function (state = initialState, action: RootAction): MainLayoutState {
  switch (action.type) {
    case getType(updateFooterVisibleHeight): {
      return {
        ...state,
        footerVisibleHeight: Math.round(action.payload)
      }
    }
    default: {
      return state;
    }
  }
}
